import React, { Fragment, useEffect, useState, useContext, useRef } from "react";
import { Container } from "reactstrap";
import { Users } from "react-feather";
import Contributions from "./Contributions";
import Appointment from "../../../assets/icons/appointment.svg";
import { getBookingColumns } from "../../../Data/Booking/BookingHistory";
import DataTable from "react-data-table-component";
import moment from "moment";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import { Link } from "react-router-dom";
import StatusIcons from "../../../CommonElements/StatusIcons";
import {
  getDashboardCount,
  getBookingbyUser,
  getContributions,
} from "../../../Services/CaptureDashboard.service";
import {
  formatDateTime,
  showAlert,
  getUserDetails,
} from "../../../Services/Shared.service";
import DashboardCards from "../DispatchDashboard/DashboardCards";

import executedCircle from "../../../assets/icons/executetd_tripscrcle.svg";
import nonFullfilledTripsCircle from "../../../assets/icons/non_fulfilled_trips_circle.svg";
import onTripCircle from "../../../assets/icons/ontrip_circle.svg";
import adhocCircle from "../../../assets/icons/adhoc_circle.svg";
import SharedDataContext from "../../../_helper/SharedData";
import BookingContext from "../../../_helper/Booking";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Spinner } from "../../../AbstractElements";

const CaptureDashboard = () => {
  const { setOnSubmitData, emptyCallback } = useContext(BookingContext);

  const { setShowApiLoader, globalCityField, dateFilter } = useContext(SharedDataContext);
  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");
  const firstUpdate = useRef(true);
  const [bookingModal, setBookingModal] = useState(false);
  const BookingModalToggle = () => setBookingModal(!bookingModal);

  const [ticketModal, setticketModal] = useState(false);
  const TicketModalToggle = () => setticketModal(!ticketModal);

  const [processData, setProcessData] = useState([]);
  const [bookingData, setBookingData] = useState([]);

  const [dashboardCount, setDashboardCount] = useState({});

  const [graphValues, setGraphValues] = useState({});

  const [dashboardCardsLoader, setDashboardCardsLoader] = useState(false);
  const [contributionsLoader, setContributionsLoader] = useState(false)
  const [bookingsLoader, setBookingsLoader] = useState(false)

  const dashboardCardData = [
    {
      title: "Total Bookings",
      backgroundColor: "#AFDFDD",
      key: "bookingCount",
      icon: <img src={Appointment} alt="Total bookings" />,
      circleIcon: executedCircle,
      isCursorHovered: false
    },
    {
      title: "Bookings Cancelled",
      backgroundColor: "#FFDAE5",
      key: "cancelBooking",
      icon: <i className="fa fa-times-circle-o"></i>,
      circleIcon: onTripCircle,
      isCursorHovered: false
    },
    {
      title: "Booking Target",
      backgroundColor: "#CAD0F9",
      key: "bookingTarget",
      icon: <Users />,
      circleIcon: nonFullfilledTripsCircle,
      isCursorHovered: false
    },
    {
      title: "Target Achieved",
      backgroundColor: "#CFCFCF",
      key: "targetArchieved",
      icon: <i className="fa fa-percent"></i>,
      circleIcon: adhocCircle,
      isCursorHovered: false
    },
  ];

  useEffect(() => {
    setOnSubmitData((prevData) => {
      return { ...prevData, fetchBookingData: fetchDashboardData };
    });

    fetchDashboardData();

    return () => {
      setOnSubmitData((prevData) => {
        return { ...prevData, fetchBookingData: emptyCallback };
      });
    };
  }, []);

  const getLast7Days = () => {
    const arr = [];
    let obj = {};
    let date = moment(new Date()).subtract(6, "d");
    for (let i = 0; i < 7; i++) {
      let formateDate = date.format("DD/MM");
      obj[formateDate] = 0;
      arr.push(formateDate);
      date.add(1, "d");
    }
    return { arr, obj };
  };

  const fetchDashboardData = async () => {
    setDashboardCardsLoader(true)
    setContributionsLoader(true);
    setBookingsLoader(true)
    const userDetails = getUserDetails();
    let body = {
      userId: userDetails.userId,
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };
    getContributions(body)
      .then((result) => {
        console.log(result, "result");
        let { arr, obj } = getLast7Days();
        console.log("obj", obj);
        result.data.map((element) => {
          if (element?.createdOn && new Date(element.createdOn)) {
            let formatedDate = moment(new Date(element.createdOn)).format(
              "DD/MM"
            );
            console.log(formatedDate, "formatedDate");
            if (formatedDate in obj) {
              obj[formatedDate] += 1;
            }
          }
        });
        const values = [];
        for (let key of arr) {
          console.log(key, "key");
          values.push(obj[key]);
        }
        setGraphValues({
          values: values,
          xAxis: arr,
        });
        setContributionsLoader(false);
      })
      .catch((err) => {
        setContributionsLoader(false);
        showAlert("error", "Something went wrong");
      });
    const userId = userDetails.userId;
    let bookingBody = {
      fromDate: FormatFromDate,
      toDate: FormatToDate,
      userId: userId,
    };
    getBookingbyUser(bookingBody).then((result) => {
      if (result.data) {
        setBookingsLoader(false)
        setBookingData(result.data);
        const bookingData = result.data.map((element, index) => {
          return {
            booking_number: (
              <Link
                to={`${process.env.PUBLIC_URL}/booking/booking-info/${element.id}`}
              >
                {element.megaCabsBookingNo}
              </Link>
            ),
            pickup_time: element.pickUpDateTime
              ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
              : "-",
            customer_name: element.custName ? element.custName : "-",
            phone_number: element.custMobile ? element.custMobile : "-",
            pickup_location: element.pickUpAddress ? (
              <>
                <span id={"pickupLocation" + index}>
                  {element.pickUpAddress}
                </span>
                <CommonToolTip
                  options={{
                    placement: "left",
                    target: "pickupLocation" + index,
                  }}
                >
                  {element.pickUpAddress}
                </CommonToolTip>
              </>
            ) : (
              "-"
            ),
            drop_location: element.destAddress ? (
              <>
                <span id={"dropLocation" + index}>
                  {element.destAddress.includes("Kempegowda")
                    ? "Kempegowda Airport"
                    : element.destAddress}
                </span>
                <CommonToolTip
                  options={{
                    placement: "left",
                    target: "dropLocation" + index,
                  }}
                >
                  {element.destAddress}
                </CommonToolTip>
              </>
            ) : (
              "-"
            ),
            status: element.currentBookingStatusType ? (
              <>
                <span className="status-icon">
                  <span id={"statusIcons" + index}>
                    <StatusIcons
                      statusType={element.currentBookingStatusType}
                    />
                  </span>
                  <CommonToolTip
                    options={{
                      placement: "left",
                      target: "statusIcons" + index,
                    }}
                  >
                    {element.currentBookingStatusType}
                  </CommonToolTip>
                </span>
              </>
            ) : (
              "-"
            ),
            booking_via: element.bookingViaType ? element.bookingViaType : "-",
          };
        });
        setProcessData(bookingData);
      }
    }).catch(err => {
      setBookingsLoader(false)
    })

    const bookingTarget = "20";

    const countBody = {
      fromDate: FormatFromDate,
      toDate: FormatToDate,
      userId: userId,
      bookingTarget: bookingTarget,
    };

    getDashboardCount(countBody).then((result) => {
      console.log(result, "count data");
      if (result.data) {
        const data = {
          ...result.data,
          ...{
            bookingTarget: bookingTarget,
          },
        };
        setDashboardCount(data);
        setDashboardCardsLoader(false)
      }
    });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchDashboardData()
  }, [dateFilter.startDate, dateFilter.endDate])

  useEffect(() => {
    const userDetails = getUserDetails();
    const serviceCityId = globalCityField?.value?.id || null;

    const bookingTarget = "20";

    const countBody = {
      fromDate: FormatFromDate,
      toDate: FormatToDate,
      userId: userDetails.userId,
      bookingTarget: bookingTarget,
      serviceCityId: serviceCityId,
    };

    setDashboardCardsLoader(true);
    getDashboardCount(countBody)
      .then((result) => {
        if (result.data) {
          console.log(result.data, "result.datatat");
          setDashboardCount(result.data);
          setDashboardCardsLoader(false)
        }
      })
      .catch((err) => {
        setDashboardCardsLoader(false)
      });
  }, [globalCityField.value]);

  return (
    <Fragment>
      {/* <Breadcrumbs parent="dashboard" mainTitle="Dashboard" /> */}
      <Container fluid={true} className="capture-dashboard">
        <div>
          <div className="dashboard-cards">
            {dashboardCardData.map((element) => {
              const obj = {
                ...element,
                ...{
                  value:
                    dashboardCount[element.key] ||
                      dashboardCount[element.key] == 0
                      ? dashboardCount[element.key]
                      : "N/A",
                },
              };
              return (
                <div className="dashboard-card-width">
                  {dashboardCardsLoader ?
                    <Skeleton className="dispatch-dashboard-data-card" />
                    : <DashboardCards element={obj} />}
                </div>
              );
            })}
          </div>
          <div className="dashboard-contributions">
            <Contributions graphValues={graphValues} loader={contributionsLoader} />
          </div>
        </div>
        <div className="table-responsive support-table">
          <DataTable
            columns={getBookingColumns(bookingData)}
            data={processData}
            center={true}
            fixedHeader
            fixedHeaderScrollHeight={"51vh"}
            progressPending={bookingsLoader}
            progressComponent={<div className="loader-box" style={{ height: "51vh" }}>
              <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
            </div>}
          />
        </div>
      </Container>
    </Fragment>
  );
};

export default CaptureDashboard;
